/**
 * By default, "import" function doesn not have any retry logic and
 * if it fail to load the chunk, the website will be broken completely.
 * This function adds retry logic to the given "fn" and retry it 5 times
 * and only then fail.
 * @example
 * importWithRetry(() => import('./test-chunk'))
 * @param  {Function} fn
 * @param  {Number}   [retriesLeft=5]
 * @param  {Number}   [interval=1000]
 * @return {Promise}
 */
function importWithRetry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 1) {
          reject(error)
          return
        }

        setTimeout(() => {
          importWithRetry(fn, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })
}

export default importWithRetry
